import React, { useState } from 'react';
import { Button, TextArea, AlertService } from '@spoiler-alert/ui-library';
import { createUseStyles } from 'react-jss';
import { useLazyQuery } from '@apollo/client';
import { propTypes, styles } from './site-editing-helpers';
import { GeocodeAddress } from '../../../graphql/queries';

const useStyles = createUseStyles(styles);

const Address = ({ site, setFieldValue }) => {
  const classes = useStyles();
  const initialState = [
    site.physicalAddress.streetAddress,
    `${site.physicalAddress.city}, ${site.physicalAddress.stateCode} ${site.physicalAddress.zipCode} ${site.physicalAddress.countryCode}`,
  ];
  const [addressLines, setAddressLines] = useState(initialState);

  const [validateDisabled, setValidateDisabled] = useState(true);

  const [geocode, { loading }] = useLazyQuery(GeocodeAddress);

  const handleAddressChange = (value) => {
    setAddressLines(value.split('\n'));
    setValidateDisabled(false);
  };

  const successMessage = (message) => {
    AlertService.alert({
      type: 'success',
      autoDismiss: true,
      dismissDelay: 3000,
      message: <span>{message} successfully updated.</span>,
    });
  };

  const handleGeocode = () => {
    geocode({ variables: { addressLines } }).then((result) => {
      setFieldValue('geocoder', 'physicalAddress', result.data.geocodeAddress.address);
      successMessage(
        result.data.geocodeAddress.address.loc.coordinates[0] +
          ' , ' +
          result.data.geocodeAddress.address.loc.coordinates[1],
      );
      setValidateDisabled(true);
    });
  };

  return (
    <div className={classes.box}>
      <TextArea value={addressLines.join('\n')} onChange={handleAddressChange} />
      <div className={classes.buttons}>
        <Button
          onClick={handleGeocode}
          secondary
          disabled={validateDisabled}
          loading={loading}
          loadingText="Geocoding..."
        >
          Validate & Geocode
        </Button>
      </div>
    </div>
  );
};

Address.propTypes = propTypes;

export default Address;
